module.exports = __webpack_public_path__ + "img/icon-cage.b66286c2.svg";